import AcknowledgeInformation from './AcknowledgeInformation.vue';
import DiscussionThread from './DiscussionThread.vue';
import EBook from './Ebook.vue';
import FileSubmission from './FileSubmission.vue';
import Flashcard from './Flashcard.vue';
import LtiResourceLink from './LtiResourceLink.vue';
import LtiTool from './LtiTool.vue';
import Podcast from './Podcast.vue';
import Quiz from './quiz/Quiz.vue';
import SlideDeck from './SlideDeck.vue';
import Survey from './Survey.vue';
import VideoTemplate from './VideoTemplate.vue';
import ViewInformation from './ViewInformation.vue';

export default {
    ViewInformation,
    AcknowledgeInformation,
    FileSubmission,
    Podcast,
    DiscussionThread,
    LtiResourceLink,
    LtiTool,
    Quiz,
    VideoTemplate,
    SlideDeck,
    Survey,
    EBook,
    Flashcard,
};
